// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_3iSj0s0O","Container":"_2wF8zREX","Image":"_1Qa8xBdK","sovrenLogo":"GX26v8Sh","Column":"_1h5RZk1A","SecondaryTitle":"_1mtBG7OH","Legal":"_367ioBhr","leftlegal":"_2u8RclDR","rightLegal":"_2RsC9U58"};
    if(module.hot) {
      // 1746735775461
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  